import { Select } from 'antd'
import styled from 'styled-components'

const StyledUnknownWordsSortByFormSelect = styled(Select)`
  width: 12rem;
  margin-left: 0.5rem;
`

export default StyledUnknownWordsSortByFormSelect
